import React from "react";

const About = () => 
{
    return(
     <div>
         <h1>Hola Amigos</h1>
<p> Humans are the best creation, and each person is exclusive. Thus, writing about myself, I’m here to express myself that what I see, what I experience and what I plan for my life. I try myself to be modest, passionate, devoted, hardworking and honest. </p>
<div class="row">
      <div class="col-lg-7">
        <h3>Though nobody can be described in a few sets of sentences. </h3><pre></pre>
          <img class="img" src="/assets/surbhi.png" alt="Designer image" />
          <p><i>Surabhi Gupta</i></p>
          <p>Web-Designer</p>
      </div>
      <div class="col-5">
        <img class="title-images" src="/assets/books-about.jpg" alt="books" />
      </div>
    </div>
     </div>
    );
}

export default About;